import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ShieldWarning = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM13 16H11V14H13V16ZM13 12H11V7H13V12Z" />
  </SvgIcon>
));

ShieldWarning.displayName = 'ShieldWarning';

export default ShieldWarning;
